import {
  requireSupabase,
} from "../lib/supabaseClient";


/* =========================================================
   HELPERS
   ========================================================= */

const toNumber = (value) => {
  const parsed =
    Number.parseInt(
      value,
      10
    );

  return Number.isNaN(parsed)
    ? 0
    : parsed;
};


/* =========================================================
   CREATE RSVP
   ========================================================= */

export async function createRsvp(
  form
) {
  const client =
    requireSupabase();


  const attending =
    form.attending === "Yes";


  const payload = {
    /* CONTACT */

    guest_name:
      form.guestName
        .trim(),

    email:
      form.email
        .trim()
        .toLowerCase(),

    phone:
      form.phone
        .trim() ||
      null,


    /* ATTENDANCE */

    attending:
      form.attending,


    /* PARTY */

    adult_count:
      attending
        ? toNumber(
            form.adultCount
          )
        : 0,

    kids_count:
      attending
        ? toNumber(
            form.kidsCount
          )
        : 0,


    /* EVENTS */

    events_attending:
      attending
        ? form.eventsAttending
        : [],


    /* FOOD */

    vegetarian_count:
      attending
        ? toNumber(
            form.vegetarianCount
          )
        : 0,

    non_vegetarian_count:
      attending
        ? toNumber(
            form.nonVegetarianCount
          )
        : 0,

    kids_meal_count:
      attending
        ? toNumber(
            form.kidsMealCount
          )
        : 0,

    dietary_notes:
      attending
        ? form.dietaryNotes
            .trim() ||
          null
        : null,


    /* SONG */

    song_request:
      attending
        ? form.songRequest
            .trim() ||
          null
        : null,


    /* MESSAGE */

    message:
      form.message
        .trim() ||
      null,
  };


  const {
    error,
  } =
    await client
      .from("rsvps")
      .insert(payload);


  if (error) {
    throw error;
  }
}


/* =========================================================
   GET ALL RSVPS
   Used by admin dashboard.
   ========================================================= */

export async function getRsvps() {
  const client =
    requireSupabase();


  const {
    data,
    error,
  } =
    await client
      .from("rsvps")
      .select("*")
      .order(
        "submitted_at",
        {
          ascending: false,
        }
      );


  if (error) {
    throw error;
  }


  return data ?? [];
}


/* =========================================================
   MARK CONTACTED
   ========================================================= */

export async function updateContacted(
  id,
  contacted
) {
  const client =
    requireSupabase();


  const {
    error,
  } =
    await client
      .from("rsvps")
      .update({
        contacted,
      })
      .eq(
        "id",
        id
      );


  if (error) {
    throw error;
  }
}


/* =========================================================
   DELETE RSVP
   ========================================================= */

export async function deleteRsvp(
  id
) {
  const client =
    requireSupabase();


  const {
    error,
  } =
    await client
      .from("rsvps")
      .delete()
      .eq(
        "id",
        id
      );


  if (error) {
    throw error;
  }
}